import { createContext, useContext, useEffect, useState } from 'react';
import { useAuth } from 'util/auth';
import { markNotificationAsRead, useNotifications } from 'util/db';

const NotificationsContext = createContext();

export const NotificationsProvider = ({ children }) => {
  const auth = useAuth();
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [notification, setNotification] = useState(null);
  const [shouldMarkAsRead, setShouldMarkAsRead] = useState(true);
  const { data: notifications } = useNotifications(auth?.user?.uid);

  const handleCloseSnackbar = async (event, reason) => {
    if (reason === 'clickaway') return;
    setOpenSnackbar(false);
    if (notification && !notification.isRead && shouldMarkAsRead) {
      markNotificationAsRead(auth.user.uid, notification.id);
      setNotification(null);
    }
  };

  useEffect(() => {
    if (notifications) {
      const unreadNotification = notifications.find((n) => !n.isRead);
      if (unreadNotification) {
        setNotification(unreadNotification);
        setOpenSnackbar(true);
        setShouldMarkAsRead(true);
      } else {
        setNotification(null);
        setOpenSnackbar(false);
      }
    } else {
      setNotification(null);
      setOpenSnackbar(false);
    }
  }, [notifications]);

  const showNewNotification = (newNotification, markAsRead = true) => {
    setNotification(newNotification);
    setOpenSnackbar(true);
    setShouldMarkAsRead(markAsRead);
  };

  return (
    <NotificationsContext.Provider
      value={{
        openSnackbar,
        notification,
        handleCloseSnackbar,
        showNewNotification,
      }}
    >
      {children}
    </NotificationsContext.Provider>
  );
};

const useNotificationsManager = () => useContext(NotificationsContext);

export default useNotificationsManager;
